import { AbstractControl, FormControl, FormGroup, ValidationErrors } from '@angular/forms'

export function confirmPasswordValidator(abstractControl: AbstractControl): ValidationErrors | null {
	const group = abstractControl as FormGroup<{
		NEW_PASSWORD: FormControl<string | null>
		CONFIRM_PASSWORD: FormControl<string | null>
	}>
	if (group) {
		const newPassword = group.controls.NEW_PASSWORD as FormControl<string>
		const confirmedPassword = group.controls.CONFIRM_PASSWORD as FormControl<string>

		if ((newPassword && newPassword.value === '') || (newPassword && confirmedPassword && newPassword.value !== confirmedPassword.value)) {
			return { passwordMismatch: true }
		}
	}

	return null
}
